import React from 'react';
import {
    CircularProgress, Button, Divider,
    Typography, withStyles
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { styles } from './styles'
import APIService from "../../../apis/amplify/APIService";
import { SectionTitle } from "../../../components/SectionTitleContainer";
import SectionTitleContainer from "../../../components/SectionTitleContainer";
import {errorBundaryHOC} from '../../../components/ErrorBoundary';
import If from "../../../components/If";
import { ERROR_TYPE, NActionButton, SUCCESS_TYPE } from "../../../components/Notification";
import Notification from "../../../components/Notification";

const MAX_MSG_LENGTH = 500;

class ContactUsContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: '',
            charsLeft: MAX_MSG_LENGTH,
            sending: false,
            notify: false,
            notifyError: null,
            notifyMessage: ''
        }
    }

    changeMessage(event) {
        let message = event.target.value;
        if (message.length > MAX_MSG_LENGTH) {
            message = message.slice(0, MAX_MSG_LENGTH);
        }
        this.setState({ message, charsLeft: MAX_MSG_LENGTH - message.length })
    }

    sendMessage() {
        this.setState({ sending: true });

        APIService.sendMessage(this.state.message)
            .then(response => {
                if (response.success === true) {
                    this.setState({
                        notify: true,
                        notifyError: false,
                        notifyMessage: 'Message sent correctly.',
                        message: ''
                    });
                } else {
                    this.setState({
                        notify: true,
                        notifyError: true,
                        notifyMessage: 'An error occurred when sending the message.'
                    });
                }
            })
            .catch(e => {
                this.setState({
                    notify: true,
                    notifyError: true,
                    notifyMessage: 'An error occurred when sending the message.'
                });
            }).finally(() => this.setState({ sending: false }));
    }

    render() {
        const { classes } = this.props;
        const { message, charsLeft, notifyMessage, notify, notifyError } = this.state;
        return (
            <div style={{ marginBottom: '50px' }}>

                <SectionTitleContainer>
                    <SectionTitle>Send us a message</SectionTitle>
                </SectionTitleContainer>

                <div className={classes.space}>
                    <div style={{minHeight: '200px', backgroundColor: 'white', padding: '10px'}}>
                            <textarea onChange={this.changeMessage.bind(this)}
                                      value={message}
                                      placeholder='Enter your message here'
                                      style={{ width: '100%', border: 'none', fontSize: '1rem', resize: 'none' }}
                                      rows={13}/>
                        <If as={Typography} condition={charsLeft !== MAX_MSG_LENGTH}
                            color="secondary"
                            className={classes.charactersLeft}>
                            {charsLeft} characters left
                        </If>
                    </div>
                    <Divider variant='fullWidth'/>
                </div>

                <div>
                    <div className={classes.sendButtonSpan}>
                        <Button onClick={this.sendMessage.bind(this)}
                                variant='contained' color='secondary' fullWidth
                                disabled={this.state.message === '' || this.state.sending === true}>
                            SEND <CircularProgress size={20} color='secondary'
                                                   style={{
                                                       display: (this.state.sending === false) && 'none',
                                                       marginLeft: '10px'
                                                   }}/>
                        </Button>
                    </div>
                </div>

                <Notification open={notify}
                              type={notifyError ? ERROR_TYPE : SUCCESS_TYPE}
                              ActionButton={
                                  <NActionButton key="close" ariaLabel="close"
                                                 onClick={() => this.setState({ notify: false })}>
                                      <Close/>
                                  </NActionButton>}
                              onClose={() => this.setState({ notify: false })}>
                    {notifyMessage}
                </Notification>

            </div>
        )
    }
}

export default withStyles(styles)(errorBundaryHOC(ContactUsContent))
